module.exports = __webpack_public_path__ + "img/market_share.181939d5.png";